var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Undo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.125 18.75V16.875H14.25C15.2417 16.875 16.0938 16.5458 16.8063 15.8875C17.5188 15.2292 17.875 14.4167 17.875 13.45C17.875 12.4833 17.5188 11.6708 16.8063 11.0125C16.0938 10.3542 15.2417 10.025 14.25 10.025H7.825L10.4125 12.6125L9.0875 13.925L4.25 9.0875L9.0875 4.25L10.4125 5.575L7.825 8.15H14.25C15.7667 8.15 17.0625 8.66042 18.1375 9.68125C19.2125 10.7021 19.75 11.9583 19.75 13.45C19.75 14.9417 19.2125 16.1979 18.1375 17.2188C17.0625 18.2396 15.7667 18.75 14.25 18.75H7.125Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon-undo.85e756802242a95186c28739bc5913d4.svg";
export { ForwardRef as ReactComponent };